import { Controller } from '@hotwired/stimulus';
import { hideModal } from '../utils/modal';

export default class extends Controller {
  static targets = ['prompt', 'success', 'error'];

  close() {
    hideModal('prorated-upgrade-modal');
  }

  error() {
    this.promptTarget.classList.add('hidden');
    this.errorTarget.classList.remove('hidden');
  }

  confirmed(event) {
    this.promptTarget.classList.add('hidden');
    this.successTarget.classList.remove('hidden');
    setTimeout(() => {
      window.location = event.detail[0].location;
    }, 2400);
  }
}
